import * as z from 'zod';

export const GetPlaceRequest = z.object({
  searchId: z.string(),
  options: z
    .object({
      sessionToken: z
        .string()
        .describe(
          'A random string which identifies an autocomplete session for billing purposes. The session begins when the user starts typing a query, and concludes when they select a place and a call to Get Place is made. Once a session has concluded, the token is no longer valid. your app must generate a fresh token for each session.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
    })
    .optional(),
});
export const GetPlaceResponse = z.object({
  place: z
    .object({
      placeId: z.string().describe('The given place id').optional(),
      address: z
        .object({
          city: z.string().optional().nullable(),
          subdivision: z.string().optional().nullable(),
          country: z.string().optional().nullable(),
          postalCode: z.string().optional().nullable(),
          addressLine1: z.string().optional().nullable(),
          addressLine2: z.string().optional().nullable(),
        })
        .describe('The Address object')
        .optional(),
      types: z.array(z.string()).optional(),
    })
    .optional(),
});
